module.exports = __webpack_public_path__ + "img/3-2.e1b07aa2.png";